<template>
  <v-container fluid v-if="!!value" class="mr-6">
    <v-row class="flex-nowrap" v-if="!!value">
      <v-btn-toggle
          dense
          v-for="(filterGroup, index) of value.groups" :key="index"
          v-model="filterGroup.selected"
          multiple
          @change="onChange()"
          class="mx-1"
      >
        <v-tooltip bottom v-for="item of filterGroup.or_group">
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-on="on" small elevation="2" :color="item.color" dense>
              <v-icon :color="item.icon_color">{{ item.icon }}</v-icon>
              {{ item.label }}
            </v-btn>
          </template>
          <span v-if="!!item.text">{{ item.text }}</span>
          <span v-else>{{ item.label }}</span>
        </v-tooltip>
      </v-btn-toggle>
      <v-btn
          v-if="hasSelected && clearable"
          small
          icon
          @click="onClear()"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-row>
  </v-container>
</template>

<script>

export default {
  name: 'BaseFilterGroupTable',
  inheritAttrs: false,
  props: {
    value: {default: null},
    clearable: {default: true},
  },

  components: {
  },

  computed: {
    hasSelected() {
      for (let filterGroup of this.value.groups) {
        if (filterGroup.selected.length >0)
          return true
      }
      return false
    },
  },

  methods: {
    onClear() {
      for (let filterGroup of this.value.groups)
        filterGroup.selected = []
      this.onChange()
    },
    onChange() {
      // console.log('onChange', this.value)
      this.$emit('change-filters', this.value)
    },
  },

  async mounted() {
  },

  data() {
    return {
      statusGroup: {},
      selectValue: [],
    }
  }
}
</script>

